import styled from "styled-components"

import theme from "@irati/ui/src/global/theme"
import {Label} from "@irati/ui/src/Typography"
import {Card} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"

import header from "../../../../../images/hris_header.svg"

interface ImgProps {
  small?: boolean
  medium?: boolean
  large?: boolean
  height?: string
}
export const Img = styled.img<ImgProps>`
  ${({small}) => small && `height: 30px;`}
  ${({medium}) => medium && `height: 50px;`}
  ${({large}) => large && `height: 70px;`}
  ${({height}) => height && `height: ${height};`}
`

export const HeaderContainer = styled.div`
  margin-top: ${`-${theme.spacing.six}`};
  margin-left: ${`-${theme.spacing.five}`};
  margin-right: ${`-${theme.spacing.five}`};
  padding: ${`${theme.spacing.four} ${theme.spacing.six} 0px ${theme.spacing.six}`};
  background-image: url(${header});
  background-repeat: no-repeat;
  background-size: cover;
`

export const ProviderLabel = styled(Label)`
  width: 130px;
  text-align: center;
  height: ${theme.spacing.seven};
  line-height: ${theme.spacing.seven};
  border: ${`1px solid ${theme.colors.greys.graphGrey}`};
  border-radius: ${theme.spacing.oneAndHalf};
  background-color: ${theme.colors.greys.lightest};
`

export const TestimonialCard = styled(Card)`
  width: 50%;
  @media (max-width: 992px) {
    width: 100%;
  }
`

export const TestimonialsContainer = styled(Flex)`
  @media (max-width: 992px) {
    flex-direction: column;
  }
`

export const BenefitsCard = styled(Card)`
  flex: 1 1 33%;
`

export const BenefitsContainer = styled(Flex)`
  @media (max-width: 992px) {
    flex-direction: column;
  }
`

export const HeaderImg = styled(Img)`
  height: 320px;

  @media (max-width: 1200px) {
    display: none;
  }
`

export const Step = styled(Flex)`
  @media (max-width: 992px) {
    width: 50%;
  }
`
